import React, { Component } from "react";
import { Modal, Input, Form, Button, Col, Row, message } from "antd";
import { createClinicAdmin } from "../../../services";
import {
  showSuccessNotification,
  showErrorNotification
} from "../../../helpers";
import NumericInput from "../../NumericInput";
const FormItem = Form.Item;
class AddEditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      countryCode: "91",
      phoneNumber: "",
      email: "",
      password: "",
      isProcessing: false
    };
  }

  handleInputChange = (value, name) => {
    this.setState({ [name]: value });
  };
  handlePhoneNumberChange = value => {
    this.setState({ phoneNumber: value });
  };
  handleSubmit = e => {
    if (e) e.preventDefault();
    const { clinicId } = this.props;
    const { name, countryCode, phoneNumber, email, password } = this.state;

    if (!name || !phoneNumber || !password) {
      message.error("Please enter required fields");
      return false;
    }
    this.setState({ isProcessing: true });
    const params = {
      country_code: countryCode,
      phone_number: phoneNumber,
      password: password,
      name: name,
      timezone: "Asia/Kolkata",
      email: email
    };
    createClinicAdmin(clinicId, params)
      .then(response => {
        if (response.data.success) {
          showSuccessNotification("Admin created successfuly");
          this.props.toggleModal();
          this.props.fetchClinicAdmins();
        } else {
          showErrorNotification(response.data.errors[0].title);
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  render() {
    const { name, phoneNumber, email, password, isProcessing } = this.state;
    const { showModal, toggleModal, selectedRecord } = this.props;
    return (
      <Modal
        visible={showModal}
        title={selectedRecord ? "Update admin" : "Create admin"}
        footer={null}
        onCancel={toggleModal}
        className="form-type-modal"
      >
        <Form layout="vertical" onSubmit={this.handleSubmit}>
          <FormItem label="Enter Name">
            <Input
              value={name}
              onChange={e => this.handleInputChange(e.target.value, "name")}
            />
          </FormItem>

          <FormItem label="Phone number">
            <NumericInput
              value={phoneNumber}
              onChange={this.handlePhoneNumberChange}
              maxLength={10}
            />
          </FormItem>
          <FormItem label="Email Address">
            <Input
              value={email}
              onChange={e => this.handleInputChange(e.target.value, "email")}
            />
          </FormItem>
          <FormItem label="Password">
            <Input.Password
              value={password}
              onChange={e => this.handleInputChange(e.target.value, "password")}
            />
          </FormItem>
          <FormItem>
            <Row type="flex" gutter={20}>
              <Col>
                <Button type="primary" htmlType="submit" loading={isProcessing}>
                  {selectedRecord ? "Update" : "Create"}
                </Button>
              </Col>
              <Col>
                <Button onClick={toggleModal}>Cancel</Button>
              </Col>
            </Row>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default AddEditModal;
